import React, { useState } from "react";

import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import "./DateFilter.css";

  const getPrevWeek = () => {
    const now = new Date();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay() - 7); // Start of previous week (Sunday)
    startOfWeek.setHours(0, 0, 0, 0);
    return startOfWeek;
  };

  const getPrevWeekEnd = () => {
    const now = new Date();
    const endOfWeek = new Date(now);
    endOfWeek.setDate(now.getDate() - now.getDay() - 1); // End of previous week (Saturday)
    endOfWeek.setHours(23, 59, 59, 999);
    return endOfWeek;
  };

const getPrevMonth = () => {
  const now = new Date();
  const firstDayOfPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  firstDayOfPrevMonth.setHours(0, 0, 0, 0);
  return firstDayOfPrevMonth;
};

const getPrevMonthEnd = () => {
  const now = new Date();
  const lastDayOfPrevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
  lastDayOfPrevMonth.setHours(23, 59, 59, 999);
  return lastDayOfPrevMonth;
};

const getPrev6Month = () => {
  const now = new Date();
  const sixMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 6, 1);
  sixMonthsAgo.setHours(0, 0, 0, 0);
  return sixMonthsAgo;
};

const getPrev6MonthEnd = () => {
  const now = new Date();
  const lastDayOfSixMonthsAgo = new Date(now.getFullYear(), now.getMonth(), 0);
  lastDayOfSixMonthsAgo.setHours(23, 59, 59, 999);
  return lastDayOfSixMonthsAgo;
};

const getPrevYear = () => {
  const now = new Date();
  const firstDayOfPrevYear = new Date(now.getFullYear() - 1, 0, 1);
  firstDayOfPrevYear.setHours(0, 0, 0, 0);
  return firstDayOfPrevYear;
};

const getPrevYearEnd = () => {
  const now = new Date();
  const lastDayOfPrevYear = new Date(now.getFullYear() - 1, 11, 31);
  lastDayOfPrevYear.setHours(23, 59, 59, 999);
  return lastDayOfPrevYear;
};

const DateFilter = ({
  setShowModal,
  startTimestamp,
  endTimestamp,
  setStartTimestamp,
  setEndTimestamp,
  period,
  setPeriod,
}) => {
  const [datePeriod, setDatePeriod] = useState(period);
  const [startDate, setStartDate] = useState(
    startTimestamp ? new Date(startTimestamp) : getPrevMonth(new Date())
  );
  const [endDate, setEndDate] = useState(() => {
    if (endTimestamp) {
      const date = new Date(endTimestamp);
      date.setHours(23, 59, 59, 999);
      return date;
    } else {
      const date = new Date();
      date.setHours(23, 59, 59, 999);
      return date;
    }
  });


  const formatDate = (date) => {
    return (
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    );
  };

  const handleClear = () => {
    setEndTimestamp(null);
    setStartTimestamp(null);
    setDatePeriod("custom");
    setPeriod("custom");
    setShowModal("");
  };

  const handleApply = () => {
    if (datePeriod === "week") {
      setPeriod("week");
      setStartTimestamp(getPrevWeek().getTime());
      setEndTimestamp(getPrevWeekEnd().getTime());
    }
    if (datePeriod === "month") {
      setPeriod("month");
      setStartTimestamp(getPrevMonth().getTime());
      setEndTimestamp(getPrevMonthEnd().getTime());
    }
    if (datePeriod === "6Month") {
      setPeriod("6Month");
      setStartTimestamp(getPrev6Month().getTime());
      setEndTimestamp(getPrev6MonthEnd().getTime());
    }
    if (datePeriod === "year") {
      setPeriod("year");
      setStartTimestamp(getPrevYear().getTime());
      setEndTimestamp(getPrevYearEnd().getTime());
    }
    if (datePeriod === "custom") {
      setPeriod("custom");
      setStartTimestamp(startDate.getTime());
      setEndTimestamp(endDate.getTime());
    }
    if (datePeriod === "filterByMonth") {
      setPeriod("filterByMonth");
      setStartTimestamp(startDate.getTime());
      setEndTimestamp(endDate.getTime());
    }
    setShowModal("");
  };

  const handleDateBtnClick = (period) => {
    setSelectedMonth(null);
    setDatePeriod(period);
    if (period === "week") {
      setEndDate(getPrevWeekEnd());
      setStartDate(getPrevWeek());
    }
    if (period === "month") {
      setEndDate(getPrevMonthEnd());
      setStartDate(getPrevMonth());
    }
    if (period === "6Month") {
      setEndDate(getPrev6MonthEnd());
      setStartDate(getPrev6Month());
    }
    if (period === "year") {
      setEndDate(getPrevYearEnd());
      setStartDate(getPrevYear());
    }
  };

  const dateFilters = [
    { label: "Custom Period", value: "custom" },
    { label: "Last Week", value: "week" },
    { label: "Last Month", value: "month" },
    { label: "Last 6 Months", value: "6Month" },
    { label: "Last Year", value: "year" },
  ];

  const monthsFilters = [
    { label: `Jan ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 1, 0  , 23, 59, 59, 999 ) },
    { label: `Feb ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 1, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 2, 0, 23, 59, 59, 999) },
    { label: `Mar ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 2, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 3, 0, 23, 59, 59, 999) },
    { label: `Apr ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 3, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 4, 0, 23, 59, 59, 999) },
    { label: `May ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 4, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 5, 0, 23, 59, 59, 999) },
    { label: `Jun ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 5, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 6, 0, 23, 59, 59, 999) },
    { label: `Jul ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 6, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 7, 0, 23, 59, 59, 999) },
    { label: `Aug ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 7, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 8, 0, 23, 59, 59, 999) },
    { label: `Sep ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 8, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 9, 0, 23, 59, 59, 999) },
    { label: `Oct ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 9, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 10, 0, 23, 59, 59, 999) },
    { label: `Nov ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 10, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 11, 0, 23, 59, 59, 999) },
    { label: `Dec ${new Date().getFullYear()}`, startDate: new Date(new Date().getFullYear(), 11, 1, 0, 0, 0, 0), endDate: new Date(new Date().getFullYear(), 12, 0, 23, 59, 59, 999) },
  ];

  const [selectedMonth, setSelectedMonth] = useState(null);

  const handleMonthBtnClick = (value) => {
    setStartDate(value.startDate);
    setEndDate(value.endDate);
    // setStartTimestamp(value.startDate.getTime());
    // setEndTimestamp(value.endDate.getTime());
    setSelectedMonth(value.label);
  };

  return (
    <div className="accountDetailsFilterPopup lg:left-0 md:-left-8 left-0 ">
      <div className="accountDateFilterBtnWrap max-w-[600px] flex-wrap">
        {dateFilters.map(({ label, value }) => (
          <div
            key={value}
            className={`accountDateFilterBtn ${
              datePeriod === value ? "selectedDateFilterBtn" : ""
            }`}
            onClick={() => handleDateBtnClick(value)}
          >
            {label}
          </div>
        ))}
        
        <div
            className={`accountDateFilterBtn ${
              datePeriod === "filterByMonth" ? "selectedDateFilterBtn" : ""
            }`}
            onClick={() => {setDatePeriod("filterByMonth")}}
          >
            Filter by month
          </div>
      </div>
      {datePeriod === "filterByMonth" && <div className="accountDateFilterBtnWrap max-w-[600px] flex-wrap">
        {monthsFilters.map((value, i) => (
          i >= new Date().getMonth() ? null :
          <div
            key={value.label}
            className={`accountDateFilterBtn ${
              selectedMonth === value.label ? "selectedDateFilterBtn" : ""
            }`}
            onClick={() => {handleMonthBtnClick(value)}}
          >
            {value.label}
          </div>
        ))}
          
        
      </div>}

      {datePeriod === "custom" && (
        <div className="accountDateModalWrap">
          <DatePicker
            calendarClassName="accountDatePickerCalender"
            startDate={startDate}
            endDate={endDate}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            inline
            maxDate={endDate}
          />
          <DatePicker
            calendarClassName="accountDatePickerCalender"
            selected={endDate}
            startDate={startDate}
            endDate={endDate}
            onChange={(date) => setEndDate(date)}
            inline
            minDate={startDate}
            maxDate={new Date()}
          />
        </div>
      )}

      <div className="accountDateFilterFooterWrap">
        <div className="accountDetailDateTextWrap">
          <p className="accountDetailDateText">{formatDate(startDate)}</p>
          <p className="accountDetailDateText" style={{ color: "#686F7B" }}>
            {">"}
          </p>
          <p className="accountDetailDateText">{formatDate(endDate)}</p>
        </div>

        <div className="accountDetailsDateFilterFooterBtns">
          <button
            style={{ width: "122px" }}
            className="accountOrderBtn accountClearBtn"
            onClick={() => {
              handleClear();
            }}
          >
            Clear
          </button>
          <button
            disabled={
              datePeriod === "" ||
              (datePeriod === "custom" && startDate === "" && endDate === "")
            }
            style={{ width: "122px" }}
            className="accountOrderBtn"
            onClick={() => {
              handleApply();
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateFilter;
